import styled, { css } from 'styled-components/macro';
import { colorBlackTransparent50, colorCoreBlack900Base, colorCoreGray100, colorCoreGray1000Base, colorCoreGray500, colorCoreGray800, defaultTransparent, colorWhiteTransparent300, colorCoreWhite1000, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
/**
 * Styles for component - 'ButtonRectangleRadioStyled'
 */
export const ButtonRectangleRadioStyled = styled.button `
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;
  width: ${({ isWidthFlexible }) => (isWidthFlexible ? '50%' : '100%')};
  height: 48px;
  gap: 8px;
  border-radius: ${CORNER_RADIUS.s};
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;

  ${({ isSelected, isRadioVisible }) => isSelected
    ? css `
          border: 1px solid ${colorCoreBlack900Base};
          background-color: ${isRadioVisible ? colorBlackTransparent50 : colorCoreBlack900Base};
          cursor: default;
          span {
            color: ${isRadioVisible ? colorCoreBlack900Base : colorCoreWhite1000};
            &:hover {
              color: ${colorCoreBlack900Base};
            }
          }
        `
    : css `
          border: 1px solid ${colorCoreGray500};
          background-color: ${defaultTransparent};
        `}

  ${({ isDisabled, isSelected, allowClickOnDisabled }) => isDisabled &&
    !isSelected &&
    css `
      background-color: ${colorBlackTransparent50};
      border: 1px solid ${colorCoreGray500};
      ${!allowClickOnDisabled ? 'cursor: not-allowed;' : ''}
      span {
        color: ${colorCoreGray1000Base};
        label {
          &::before {
            border-color: ${colorCoreGray500};
          }

          &::after {
            background-color: ${colorCoreGray500};
          }
        }
      }
    `}

  ${({ isSelected, isRadioVisible }) => !isSelected
    ? css `
          &:hover {
            border: 1px solid ${colorCoreBlack900Base};
            color: ${colorCoreBlack900Base};
            background-color: ${colorBlackTransparent50};
            span {
              color: ${colorCoreBlack900Base};
            }
          }
        `
    : css `
          &:hover {
            span {
              color: ${isRadioVisible ? colorCoreBlack900Base : colorCoreWhite1000};
            }
          }
        `}
`;
/**
 * Styles for component - 'ButtonSquareStyled'
 */
const HoverStyles = css `
  background-color: ${colorBlackTransparent50};
  border: 1px solid ${colorCoreBlack900Base};
`;
export const ButtonSquareStyled = styled.button `
  box-sizing: border-box;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  padding: 10px;
  border-radius: ${CORNER_RADIUS.s};

  min-width: 44px;
  min-height: 44px;

  transition: background-color 150ms, border 150ms cubic-bezier(0.39, 0.58, 0.57, 1) 150ms;

  background-color: ${defaultTransparent};
  border: 1px solid ${colorCoreGray500};
  -webkit-tap-highlight-color: transparent;

  &:hover {
    ${HoverStyles};

    cursor: pointer;
  }

  ${({ isSelected }) => isSelected &&
    css `
      background-color: ${colorCoreBlack900Base};
      border: 1px solid ${colorCoreBlack900Base};
      color: ${colorCoreGray100};

      &:hover {
        cursor: default;
        background-color: ${colorCoreBlack900Base};
        border: 1px solid ${colorCoreBlack900Base};
        color: ${colorCoreGray100};
      }
    `}

  ${({ isDisabled }) => isDisabled &&
    css `
      background-color: ${colorWhiteTransparent300};
      border: 1px solid ${colorCoreGray500};
      color: ${colorCoreGray1000Base};
      cursor: not-allowed;

      span {
        color: ${colorCoreGray1000Base};
      }

      &:hover {
        cursor: not-allowed;
        border: 1px solid ${colorCoreGray800};
      }
    `}
`;
